import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  loginForm: FormGroup;
  showSuccessPopup = false;

  constructor(private fb: FormBuilder, private apiService: ApiService, private cookie: CookieService
    , private router: Router
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  onSubmit() {
    if (this.loginForm.valid) {
      const { username, password } = this.loginForm.value;
      const formData = new FormData();
      formData.append('username', username);
      formData.append('password', password);
      this.apiService.login(formData).subscribe({
        next: (res) => {
          this.cookie.set('access_token', res.access_token);
          this.cookie.set('refresh_token', res.refresh_token);
          this.router.navigate(['/home']);
        },
        error: (err) => {
          this.showSuccessPopup = true;
        }
      });
    }
  }
}
